export default __webpack_public_path__ + "static/media/soulabsorption.8402c40d.png";